import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import reportWebVitals from "./reportWebVitals";
import ThemeContext from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import { LocationProvider } from "./context/LocationContext";
import { CategoryFilterProvider } from "./context/CategoryFilterContext";
import { SportProvider } from "./context/SportContext";
import { MenuManagementProvider } from "./context/MenuManagementContext";
import { AccountManagementProvider } from "./context/AccountManagementContext";
import "./i18n/i18n";
import { GenderProvider } from "./context/GenderContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <AuthProvider>
          <MenuManagementProvider>
            <AccountManagementProvider>
          <ThemeContext>
             <CategoryFilterProvider>
              <SportProvider>
                 <GenderProvider>
                  <LocationProvider>
                  <ToastContainer />
                  <App />
                </LocationProvider>
                 </GenderProvider>
                
              </SportProvider>
            </CategoryFilterProvider>
          </ThemeContext>
           </AccountManagementProvider>
          </MenuManagementProvider>
        </AuthProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
reportWebVitals();
